import script from "./UploadDocumentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadDocumentsView.vue?vue&type=script&setup=true&lang=js"

import "./UploadDocumentsView.vue?vue&type=style&index=0&id=89a2ec68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89a2ec68"]])

export default __exports__